import React from 'react';

import { Heading, Container, Row, Col, Text } from 'aplazame-design-system';

import styleSass from './style.module.scss';
import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';
import textStyle from 'aplazame-design-system/src/scss/text.module.scss';


export default function NumbersSection({
    title,
    titleTag,
    numbers,
    colorScheme,
    style
}) {
    const [currentSlide, setCurrentSlide] = React.useState(0);
    colorScheme = colorScheme?.toLowerCase();
    let wrapperStyle = false;
    switch (style) {
        case "Style 1":
            wrapperStyle = styleSass.style1;
            break;
        case "Style 2":
            wrapperStyle = styleSass.style2;
            break;
        case "Style 3":
            wrapperStyle = styleSass.style3;
            break;
        case "Style 4":
            wrapperStyle = styleSass.style4;
            break;
        case "Style 5":
            wrapperStyle = styleSass.style5;
            break;
        case "Style 6":
            wrapperStyle = styleSass.style6;
            break;
        default:
            break;
    }

    function stripHTML(html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    }

    React.useEffect(() => {
        numbers.forEach(number => {
            number.ariaLabel = stripHTML(number.titleNumber) + stripHTML(number.text);
        });
    }, [numbers]);

    if (!wrapperStyle) { // old component
        return (
            <section>
                <Container
                    pt={{
                        xs: 10,
                        lg: 15
                    }}
                    pb={{
                        xs: 10,
                        lg: 15
                    }}
                >
                    <Row className="text-center">
                        <Col
                            mb={{ lg: 5 }}
                            col={{ lg: 8 }}
                            offset={{ lg: 2 }}
                        >
                            <Heading
                                tag={titleTag}
                                className={`${styleSass.heading} pb-5`}
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                            >
                                {title}
                            </Heading>
                        </Col>
                        {numbers.map((number, i) => (
                            <Col
                                key={i}
                                pt={{
                                    xs: 5
                                }}
                                offset={{
                                    lg: numbers.length === 3 && !i ? 1 : 0
                                }}
                                col={{
                                    md: numbers.length === 3 ? 4 : 6,
                                    lg: numbers.length === 4 ? 3 : (i === 1 ? 4 : 3)
                                }}
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                                data-sal-delay={`xs-none--lg-${i * 200}`}
                            >
                                <div role="text" aria-label={number.ariaLabel}>
                                    <Heading
                                        aria-hidden="true"
                                        tag="p"
                                        mb={{
                                            xs: 1,
                                            md: 3
                                        }}
                                        className={`h1 ${textStyle.gradual} ${styleSass.number} ${colorStyle[`color--${colorScheme}`]}`}
                                    >
                                        {number.titleNumber}
                                    </Heading>
                                    <div aria-hidden="true">
                                        <Text
                                            tag="div"
                                            className={`h3 pl-md-3 pr-md-3 ${numbers.length === 3 && i === 1 ? 'pl-lg-10 pr-lg-10' : ''} ${styleSass.numberText}`}
                                        >
                                            {number.text}
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
        );
    }


    return (
        <section className={`${wrapperStyle}`} >
            <Container
                pt={{
                    xs: 10,
                    lg: 15
                }}
                pb={{
                    xs: 10,
                    lg: 15
                }}
            >
                <Row className="text-center">
                    <Col
                        mb={{ lg: 5 }}
                        col={{ lg: 8 }}
                        offset={{ lg: 2 }}
                    >
                        <Heading
                            tag={titleTag}
                            className={`${styleSass.heading} pb-5`}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                        >
                            {title}
                        </Heading>
                    </Col>
                </Row>
                <Row className="text-center">
                    {numbers.map((number, i) => (
                        <Col
                            className={wrapperStyle != "" ? styleSass.box : ""}
                            key={i}
                            col={{ md: numbers.length === 3 ? 4 : 6 }}
                        >
                            <div
                                onMouseEnter={() => setCurrentSlide(i)}
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                                data-sal-delay={`xs-none--lg-${i * 200}`}>
                                <div className={styleSass.wrapperContent} aria-label={number.ariaLabel}>
                                    <Heading
                                        tag="p"
                                        mb={{
                                            xs: 1,
                                            md: 3
                                        }}
                                        className={`h1 ${textStyle.gradual} ${styleSass.number} ${colorStyle[`color--${colorScheme}`]}`}
                                    >
                                        {number.titleNumber}
                                    </Heading>
                                    <Text
                                        tag="div"
                                        className={`h3 pl-md-3 pr-md-3 ${numbers.length === 3 && i === 1 ? 'pl-lg-10 pr-lg-10' : ''} ${styleSass.numberText}`}
                                    >
                                        {number.text}
                                    </Text>
                                </div>
                                <img src={'/hover_number_section.svg'} alt="Lines Drawing" />
                            </div>
                        </Col>
                    ))}
                </Row>
                {/* <Row className="text-center"> */}
                {/* <Col> */}
                <div className={styleSass.paginationContainer}>
                    {currentSlide + 1}/{numbers.length}
                </div>
                {/* </Col> */}
                {/* </Row> */}
            </Container>
        </section>
    );
}
